import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NoContent } from 'app/components';
import { WithEventsWatchlistBtn, ButtonWatchlist } from 'app/modules/watchlist';
import { getDisplayNameHOC } from 'app/utils';
import useConfig from 'app/hooks/useConfig';

const mapEntity = events =>
  events.map(({ entity }) => ({
    id: entity.id,
    picture: entity.poster,
    title: entity.title
  }));

const mapStateToProps = ({ watchlist: { events } }) => ({
  listContent: mapEntity(events)
});

const WithEventsWatchlistCarousel = WrappedComponent => {
  const displayName = `WithEventsWatchlistCarousel(${getDisplayNameHOC(WrappedComponent)})`;
  const WatchListBtn = WithEventsWatchlistBtn(ButtonWatchlist);
  const propTypes = {
    listContent: PropTypes.arrayOf(PropTypes.object).isRequired
  };

  const Component = ({ listContent, ...props }) => {
    const { routes } = useConfig();
    const [t] = useTranslation();
    const sectionTitle = t('watchList.my_events');
    const routePattern = routes.eventDetails.pattern;

    return (
      <WrappedComponent
        {...props}
        listContent={listContent}
        routePattern={routePattern}
        sectionTitle={sectionTitle}
        noContent={() => <NoContent svgId="no-movies" text={t('watchList.empty')} type="account" />}
        watchListBtn={id => <WatchListBtn id={id} isInWatchList />}
      />
    );
  };

  Component.displayName = displayName;
  Component.propTypes = propTypes;

  return connect(
    mapStateToProps,
    null
  )(Component);
};

export default WithEventsWatchlistCarousel;
